import React from 'react'
import {
  IconTrash,
} from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import {
  fileImage1,
  fileImage2,
  fileImage3,
  fileImage4,
  fileImage5,
  fileImage6,
  fileImage7,
  fileImage8,
  fileImage9,
  fileImage10,
  fileImage11,
  fileImage12,
  fileImage13,
} from '../../assets/images'
import Breadcrumb from '../../components/common/Breadcrumb'

export default function FileImages() {

  const fileImagesList = [
    {
      image: fileImage1,
      name: "img21545ds.jpg",
      size: "2MB",
      date: "Nov 02, 2017",
    },
    {
      image: fileImage2,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage3,
      name: "img21545ds.jpg",
      size: "2MB",
      date: "Nov 02, 2017",
    },
    {
      image: fileImage4,
      name: "img21545ds.jpg",
      size: "2MB",
      date: "Nov 02, 2017",
    },
    {
      image: fileImage5,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage6,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage7,
      name: "img21545ds.jpg",
      size: "2MB",
      date: "Nov 02, 2017",
    },
    {
      image: fileImage3,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage8,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage9,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage10,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage11,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage12,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
    {
      image: fileImage13,
      name: "img21545ds.jpg",
      size: "5MB",
      date: "Dec 15, 2017",
    },
  ]

  return (
    <>
      <Breadcrumb title="File Images" path="File Manager / File Images" />
      <div className='grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 lg:gap-30 gap-15'>
        {fileImagesList.map((item, key) => (
          <Link to="#" key={key} className='bg-bg-dark shadow-light rounded-lg overflow-hidden relative group'>
            <div className='h-[180px]'>
              <img src={item.image} alt='File Poster' width="378" height="236" className='aspect-video w-full h-full object-cover' />
            </div>
            <div className='border-t border-border p-10'>
              <p className="mb-5 text-text-primary">{item.name}</p>
              <small className='text-blue flex items-center justify-between gap-10'>
                Size: {item.size}
                <span className="text-text-secondary">{item.date}</span>
              </small>
            </div>
            <button className='bg-danger rounded-[4px] px-10 py-[8px] absolute right-10 top-10 z-[1] hidden group-hover:block'>
              <IconTrash className='text-white w-[18px] h-[18px] stroke-[1.5]' />
            </button>
          </Link>
        ))}
      </div>
    </>
  )
}
